import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-587586ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "mt-2 grid grid-cols-2 gap-3" }
const _hoisted_3 = { class: "mt-2 grid grid-cols-2 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Создать запись",
    class: "xxl",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.addContract,
    scrollable: "",
    loading: _ctx.state.is_loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_input, {
          placeholder: "Номер договора",
          "is-invalid": _ctx.state_form$.number.$error,
          "validation-errors": _ctx.state_form$.number.$errors,
          value: _ctx.state.number,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.number) = $event))
        }, null, 8, ["is-invalid", "validation-errors", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Тип договора",
          loading: _ctx.data_state.types.is_loading,
          failed: _ctx.data_state.types.is_failed,
          "error-text": "При получении списка типов произошла ошибка",
          "is-invalid": _ctx.state_form$.typeId.$error,
          "validation-errors": _ctx.state_form$.typeId.$errors,
          options: _ctx.data_state.types.list,
          value: _ctx.state.typeId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.typeId) = $event)),
          "infinite-scroll": "",
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1)))
        }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Подразделение",
          loading: _ctx.data_state.subdivisions.is_loading,
          failed: _ctx.data_state.subdivisions.is_failed,
          "error-text": "При получении списка подразделений произошла ошибка",
          options: _ctx.data_state.subdivisions.list,
          "is-invalid": _ctx.state_form$.subdivisionId.$error,
          "validation-errors": _ctx.state_form$.subdivisionId.$errors,
          value: _ctx.state.subdivisionId,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
          onRefresh: _ctx.loadSubdivisions,
          onChange: _ctx.onSubdivisionSelected
        }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"])
      ]),
      _createVNode(_component_the_input, {
        class: "mt-2",
        type: "date",
        placeholder: "Дата договора",
        "is-invalid": _ctx.state_form$.date.$error,
        "validation-errors": _ctx.state_form$.date.$errors,
        value: _ctx.state.date,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.date) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      (_ctx.state.is_not_company)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 0,
            class: "mt-2",
            placeholder: "БИН",
            "is-invalid": _ctx.state_form$.companyBin.$error,
            "validation-errors": _ctx.state_form$.companyBin.$errors,
            value: _ctx.state.companyBin,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.companyBin) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_checkbox, {
          label: "Нет компании",
          value: _ctx.state.is_not_company,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.is_not_company) = $event)),
          disabled: _ctx.state.is_loading,
          onChange: _ctx.onCheckboxChange
        }, null, 8, ["value", "disabled", "onChange"]),
        (_ctx.state.is_not_company)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 0,
              placeholder: "Компания",
              "is-invalid": _ctx.state_form$.companyName.$error,
              "validation-errors": _ctx.state_form$.companyName.$errors,
              value: _ctx.state.companyName,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.companyName) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]))
          : (_openBlock(), _createBlock(_component_the_select, {
              key: 1,
              class: "mt-2",
              placeholder: "Компания",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка произошла ошибка",
              options: _ctx.data_state.companies.list,
              value: _ctx.state.companyId,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.companyId) = $event)),
              "is-invalid": _ctx.state_form$.companyId.$error,
              "validation-errors": _ctx.state_form$.companyId.$errors,
              "infinite-scroll": "",
              "search-without-refresh": "",
              onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
              onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
              onSearch: _ctx.searchCompanies,
              onOptionBySearch: _ctx.unshiftFindedCompany,
              onChange: _ctx.onCompanySelected
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch", "onChange"]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.statusId,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.statusId) = $event)),
          "is-invalid": _ctx.state_form$.statusId.$error,
          "validation-errors": _ctx.state_form$.statusId.$errors,
          placeholder: "Статус",
          loading: _ctx.data_state.statuses.is_loading,
          options: _ctx.data_state.statuses.list,
          failed: _ctx.data_state.statuses.is_failed,
          "error-text": "При получении списка произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _ctx.loadStatuses
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.initiatorId,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.initiatorId) = $event)),
          "is-invalid": _ctx.state_form$.initiatorId.$error,
          "validation-errors": _ctx.state_form$.initiatorId.$errors,
          placeholder: "Инициатор",
          loading: _ctx.data_state.initiators.is_loading,
          options: _ctx.data_state.initiators.list,
          failed: _ctx.data_state.initiators.is_failed,
          "error-text": "При получении списка произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadInitiators(_ctx.data_state.initiators.pagination.current_page))),
          onLoadmore: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadMoreInitiators(_ctx.data_state.initiators.pagination.current_page + 1))),
          onSearch: _ctx.searchInitiators,
          onOptionBySearch: _ctx.unshiftFindedInitiator,
          onChange: _ctx.onInitiatorSelected
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch", "onChange"])
      ])
    ]),
    _: 1
  }, 8, ["onCancel", "onConfirm", "loading"]))
}